import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isOfferHotels } from '@websky/core/src/SearchForm/store/offerHotels/selectors';
import { offerHotelsAction } from '@websky/core/src/SearchForm/store/offerHotels/actions';
import Checkbox from '../Checkbox/Checkbox';
const OfferHotels = React.memo(() => {
    const { t } = useTranslation('SearchForm');
    const dispatch = useDispatch();
    const isOfferHotelsActive = useSelector(isOfferHotels);
    const toggleOfferHotels = () => {
        dispatch(offerHotelsAction(!isOfferHotelsActive));
    };
    return React.createElement(Checkbox, { label: t('Offer hotels'), checked: isOfferHotelsActive, onChange: toggleOfferHotels });
});
export default OfferHotels;
